import { render, staticRenderFns } from "./SLive1.vue?vue&type=template&id=b94bd7d0&scoped=true"
import script from "./SLive1.vue?vue&type=script&lang=js"
export * from "./SLive1.vue?vue&type=script&lang=js"
import style0 from "./SLive1.vue?vue&type=style&index=0&id=b94bd7d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94bd7d0",
  null
  
)

export default component.exports